<div class="relative">
  <div class="opacity-0 absolute">rating {{ rating }} out of 5 stars</div>
  @if (rating) {
    <span aria-hidden="true" class="text-sm text-gold">
      @if (rating >= 1) {
        <i class="fa fa-star"></i>
      }
      @if (rating >= 2) {
        <i class="fa fa-star"></i>
      }
      @if (rating >= 3) {
        <i class="fa fa-star"></i>
      }
      @if (rating >= 4) {
        <i class="fa fa-star"></i>
      }
      @if (rating >= 5) {
        <i class="fa fa-star"></i>
      }
      @if (rating % 2 >= 0.5 &&
        rating != 5 &&
        rating != 4 &&
        rating != 3 &&
        rating != 2 &&
        rating != 1) {
        <i class="fa fa-star-half"
        ></i>
      }
      @if (showRatingCount) {
        <strong class="text-sm">({{ rating }})</strong>
      }
    </span>
  }
</div>
